(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.de = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Keine Daten gefunden'
      },
      combobox: {
        placeholder: 'Auswahl',
        searchPlaceholder: 'Suchen'
      },
      datepicker: {
        apply: 'Anwenden',
        clearSelection: 'Keine',
        pickADays: 'Tage auswählen',
        prevYear: 'Vorheriges Jahr',
        nextYear: 'Nächstes Jahr',
        prevMonth: 'Vorheriger Monat',
        nextMonth: 'Nächster Monat',
        year: '',
        month1: 'Januar',
        month2: 'Februar',
        month3: 'März',
        month4: 'April',
        month5: 'Mai',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'August',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'Dezember',
        weeks: {
          sun: 'So',
          mon: 'Mo',
          tue: 'Di',
          wed: 'Mi',
          thu: 'Do',
          fri: 'Fr',
          sat: 'Sa'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mrz',
          apr: 'Apr',
          may: 'Mai',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Dez'
        },
        pickADay: 'Wählen Sie einen Tag'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Keine Daten gefunden'
      },
      filepicker: {
        browse: 'Durchsuchen',
        select: 'Eine Datei wählen'
      },
      filter: {
        apply: 'Anwenden',
        cancel: 'Abbrechen',
        filterButton: 'Filter',
        reset: 'Filter zurücksetzen',
        resetDefault: 'Auf Standard zurücksetzen'
      },
      search: {
        noDataMessage: 'Keine Daten gefunden'
      },
      'multi-search': {
        'separator-and': 'UND',
        'search-button': 'Suchen',
        'search-placeholder': 'Nach Namen suchen'
      },
      select: {
        all: 'Alle',
        clearSelection: 'Auswahl aufheben',
        noMatch: 'Keine Daten gefunden',
        noData: 'Keine Daten',
        placeholder: 'Auswahl',
        item: 'Element(e)',
        selected: 'markiert',
        found: 'gefunden'
      },
      upload: {
        browseButton: 'Durchsuchen',
        text: 'Dateien zum Upload hierher ziehen oder auf \'Durchsuchen\' klicken',
        tip: 'Sie können 10 Dateien mit je bis zu 25 MB hochladen'
      },
      table: {
        emptyText: 'Keine Daten'
      },
      tree: {
        emptyText: 'Keine Daten'
      }
    }
  };
  _exports.default = _default;
});